import { createFileRoute } from '@tanstack/react-router'

import { SenderHealthPage } from '#/modules/communication/sender-health-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/sender-health')({
  component: SenderHealthPage,
  validateSearch: validateListSearch,
})
